var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"body search"},[_c('div',{staticClass:"input-group m-b-0"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"icon-magnifier"})])]),_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":"Search..."}})])])])
}]

export { render, staticRenderFns }